import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 19l-4 -2l-6 3v-13l6 -3l6 3l6 -3v9","key":"svg-0"}],["path",{"d":"M9 4v13","key":"svg-1"}],["path",{"d":"M15 7v6.5","key":"svg-2"}],["path",{"d":"M17 17v5","key":"svg-3"}],["path",{"d":"M21 17v5","key":"svg-4"}]]

const IconMapPause = createReactComponent('outline', 'map-pause', 'MapPause', __iconNode);

export default IconMapPause;